import {
  RoleType,
  RoleTypeEnum,
  RoleAccessModel,
} from "src/app/store/models/role.model";
import {
  CostModel,
  ActionModel,
  FindingModel,
  AssessmentModel,
  FindingNoteModel,
} from "src/app/store/models/assesment.model";
import {
  QueryCondition,
  FirebaseService,
} from "../firebase-service/firebase.service";
import { inject, Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { collection } from "src/app/utils/collection.util";
import { FileModel } from "src/app/store/models/file.model";
import { StorageService } from "../storage-service/storage.service";
import { AssetModel, SiteModel } from "src/app/store/models/asset.model";
import { of, map, from, catchError, Observable, BehaviorSubject } from "rxjs";
import { AllCacheModel } from "src/app/store/models/offline-configuration.model";

export type StepType = "AssetAssessment" | "ReviewAndSubmit" | "Approval";

interface Stepper {
  title: string;
  type: StepType;
  enabled: boolean;
  iconActive: string;
  completed: boolean;
  iconEnabled: string;
  description?: string;
  haveAccess?: boolean;
  iconCompleted: string;
}
@Injectable({
  providedIn: "root",
})
export class AssessmentService {
  private translate = inject(TranslateService);
  private storageService = inject(StorageService);
  private firebaseService = inject(FirebaseService);

  isLightboxOpen = false;
  lightboxStartIndex = 0;
  lightboxImages: string[] = [];
  isViewDefeactTypeClicked = false;
  role: RoleAccessModel | undefined;
  public form = new BehaviorSubject<number>(1);
  public modalOpen = new BehaviorSubject(false);
  public isViewMode = new BehaviorSubject(false);
  public isNoFinding = new BehaviorSubject(false);
  public isAddFinding = new BehaviorSubject(false);
  public cost = new BehaviorSubject<CostModel>({});
  isReadOnly = new BehaviorSubject<boolean>(false);
  public selectedType = new BehaviorSubject<string>("");
  public isEmptyfindingModal = new BehaviorSubject(false);
  public isApproved = new BehaviorSubject<boolean>(false);
  public showAssetFindingList = new BehaviorSubject(false);
  public globalFindingId = new BehaviorSubject<string>("");
  public isAssessmentModalOpen = new BehaviorSubject(false);
  public showFindingActionForm = new BehaviorSubject(false);
  public showFindingNotesModal = new BehaviorSubject(false);
  public selectedAsset = new BehaviorSubject<AssetModel>({});
  public isFindingFromBudgetTable = new BehaviorSubject(false);
  public selectedAction = new BehaviorSubject<ActionModel>({});
  isCompletedAssessment$ = new BehaviorSubject<boolean>(false);
  public showFindingNotesFormModal = new BehaviorSubject(false);
  public selectedFinding = new BehaviorSubject<FindingModel>({});
  public asseessmentSplitView = new BehaviorSubject<boolean>(false);
  public findingNotes = new BehaviorSubject<FindingNoteModel[]>([]);
  selectedAssessment$ = new BehaviorSubject<AssessmentModel | null>(null);
  selectedAssetId: BehaviorSubject<string> = new BehaviorSubject<string>("");
  selectedAssessmentId: BehaviorSubject<string> = new BehaviorSubject<string>(
    "",
  );
  deletedImages: BehaviorSubject<FileModel[]> = new BehaviorSubject<
    FileModel[]
  >([]);
  public actionListGlobal = new BehaviorSubject<ActionModel[]>([]);
  private riskLevelSubject = new BehaviorSubject<string>(""); // Default value
  riskLevel$ = this.riskLevelSubject.asObservable();
  polygons: { [key: string]: google.maps.Polygon } = {};
  private imageAddedSubject = new BehaviorSubject<boolean>(false);
  imageAdded$ = this.imageAddedSubject.asObservable();

  public isCallActionApis = new BehaviorSubject<boolean>(false);
  public isStepperExpanded = new BehaviorSubject<boolean>(true);
  public isSendForApproval = new BehaviorSubject<boolean>(true);
  public refreshFindingsList = new BehaviorSubject<boolean>(false);
  public activeStep = new BehaviorSubject<StepType>("AssetAssessment");
  public siteHaveApproveAssessment = new BehaviorSubject<boolean>(false);
  public isActionManagementLoading = new BehaviorSubject<boolean>(false);

  stepper: Stepper[] = [
    {
      enabled: true,
      completed: false,
      type: "AssetAssessment",
      title: this.translate.instant("STEPPER_PERFORM_STRUCTURAL_ASSESSMENT"),
      iconActive: "../../../../assets/assessment/stepper/step1-active.svg",
      iconEnabled: "../../../../assets/assessment/stepper/step1-enabled.svg",
      iconCompleted:
        "../../../../assets/assessment/stepper/step1-completed.svg",
      description: `<ul class="space-y-[4px]">
                    <li class="relative pl-[16px]">
                      <span class="absolute left-0 top-0">●</span>
                      ${this.translate.instant("STEPPER_SELECT_ZONE")} <b>${this.translate.instant("STEPPER_TAP_ON_ASSET_TO_BEGIN")}</b>. ${this.translate.instant("STEPPER_ASSET_GEOLOCATION_UPDATE")}
                    </li>
                    <li class="relative pl-[16px]">
                      <span class="absolute left-0 top-0">●</span>
                      ${this.translate.instant("STEPPER_FOLLOW_GUIDANCE_ASSET")} <b>${this.translate.instant("STEPPER_CREATE_NEW_OR_UPDATE_EXISTING_FINDINGS")}</b>
                    </li>
                    <li class="relative pl-[16px]">
                      <span class="absolute left-0 top-0">●</span>
                      ${this.translate.instant("STEPPER_ONCE_ALL_DEFECTS_RECORDED")}
                    </li>
                  </ul>
`,
    },
    {
      enabled: false,
      completed: false,
      type: "ReviewAndSubmit",
      title: this.translate.instant("STEPPER_REVIEW_AND_SUBMIT"),
      iconActive: "../../../../assets/assessment/stepper/step2-active.svg",
      iconEnabled: "../../../../assets/assessment/stepper/step2-enabled.svg",
      iconCompleted:
        "../../../../assets/assessment/stepper/step2-completed.svg",
      description: this.translate.instant("REVIEW_&_SUBMIT_MSG"),
    },
    {
      enabled: false,
      completed: false,
      type: "Approval",
      title: this.translate.instant("STEPPER_APPROVAL"),
      iconActive: "../../../../assets/assessment/stepper/step3-active.svg",
      iconEnabled: "../../../../assets/assessment/stepper/step3-enabled.svg",
      iconCompleted:
        "../../../../assets/assessment/stepper/step3-completed.svg",
      description: this.translate.instant("STEPPER_FINAL_APPROVAL_ASSESSMENT"),
    },
  ];

  constructor() {}

  // *** This function will only be called based on condition during first time page load ***
  setCompletedStepFirstTime(stepType: StepType, role?: RoleAccessModel): void {
    const stepIndex = this.stepper.findIndex((step) => step.type === stepType);
    this.stepper.forEach((step, idx) => {
      if (idx <= stepIndex) {
        step.enabled = true;
        step.completed = true;
      } else if (idx === stepIndex + 1) {
        if (
          this.stepper[stepIndex + 1]?.type === "Approval" &&
          role?.assessmentApprover
        ) {
          step.enabled = true;
          step.completed = false;
        } else if (
          this.stepper[stepIndex + 1]?.type === "Approval" &&
          !role?.assessmentApprover
        ) {
          step.enabled = false;
          step.completed = false;
        } else {
          step.enabled = true;
        }
      } else if (idx > stepIndex + 1) {
        step.enabled = false;
        step.completed = false;
      }
    });
    if (stepIndex + 1 < this.stepper.length) {
      if (
        this.stepper[stepIndex + 1]?.type === "Approval" &&
        !role?.assessmentApprover
      ) {
        this.activeStep.next(this.stepper[stepIndex]?.type);
      } else this.activeStep.next(this.stepper[stepIndex + 1]?.type);
    } else {
      if (
        this.stepper[stepIndex]?.type === "Approval" &&
        !role?.assessmentApprover
      ) {
        this.activeStep.next(this.stepper[stepIndex - 1]?.type);
      } else this.activeStep.next(this.stepper[stepIndex]?.type);
    }
  }

  isStepCompleted(stepType: StepType): boolean {
    const step = this.stepper.find((s) => s.type === stepType);
    return step ? step.completed : false;
  }

  // *** This function will be called when any step is completed after any action ***
  setCompletedStep(stepIndex: number): void {
    this.stepper[stepIndex].completed = true;
    // Enable the next step if it exists
    if (stepIndex + 1 < this.stepper.length) {
      if (this.stepper[stepIndex + 1].enabled === false) {
        this.stepper[stepIndex + 1].enabled = true;
      }
    }
  }

  resetStepper(): void {
    this.stepper.forEach((step, idx) => {
      if (idx === 0) {
        step.enabled = true;
        step.completed = false;
      } else {
        step.enabled = false;
        step.completed = false;
      }
    });
    this.activeStep.next("AssetAssessment");
  }

  public findingActionPermission(): boolean {
    return !!(
      this.role?.findingCreation ||
      this.role?.findingEdition ||
      this.role?.actionCreation ||
      this.role?.actionEdition
    );
  }

  public AssessmentPermission(): boolean {
    return !!(this.role?.assessmentCreation || this.role?.assessmentEdition);
  }

  public AssessmentCreationPermission(): boolean {
    return !!this.role?.assessmentCreation;
  }

  public AssessmentEditionPermission(): boolean {
    return !!this.role?.assessmentEdition;
  }

  setRiskLevel(level: string): void {
    this.riskLevelSubject.next(level);
  }
  setImageAdded(status: boolean) {
    this.imageAddedSubject.next(status);
  }

  public findSites(
    siteId: string,
    offline: boolean = false,
  ): Observable<SiteModel[]> {
    if (offline) {
      return from(this.storageService.get("allCache")).pipe(
        map((cachedata: AllCacheModel[] = []) => {
          const sites = cachedata[0]?.sites ?? [];
          const site = sites.find((_site) => _site?.id === siteId);
          return site ? [site] : [];
        }),
      );
    }
    return this.firebaseService.getDocumentsWithCondition(
      collection.sites,
      "id",
      "==",
      siteId,
    );
  }

  openLightbox(images: string[], index: number) {
    this.lightboxImages = images;
    this.lightboxStartIndex = index;
    this.isLightboxOpen = true;
  }

  closeLightbox() {
    this.isLightboxOpen = false;
  }

  openDefectModal() {
    this.isViewDefeactTypeClicked = true;
  }

  closeDefectModal() {
    this.isViewDefeactTypeClicked = false;
  }

  calculateCapexCost(actions: ActionModel[]): number {
    return actions.reduce((sum, action) => {
      if (action?.cost?.estCost?.selectedType === "capex") {
        const cost = action.cost?.estCost?.total || 0;
        return sum + cost;
      }
      return sum;
    }, 0);
  }

  calculateOpexCost(actions: ActionModel[]): number {
    return actions.reduce((sum, action) => {
      if (action?.cost?.estCost?.selectedType === "opex") {
        const cost = action.cost?.estCost?.total || 0;
        return sum + cost;
      }
      return sum;
    }, 0);
  }

  getFindingActions(
    findingId: string,
    assessmentId: string,
  ): Observable<ActionModel[]> {
    if (!findingId || !assessmentId) return of([]);

    const actionFilter: QueryCondition[] = [
      { field: "findingId", operator: "==", value: findingId },
      { field: "assessmentId", operator: "==", value: assessmentId },
    ];

    return this.firebaseService
      .getSubDocuments(
        assessmentId,
        collection.assessments,
        collection.action,
        "AND",
        actionFilter,
      )
      .pipe(
        map((data) => data.map((item) => item as ActionModel)),
        catchError((error) => {
          console.error("error", error);
          return of([]);
        }),
      );
  }
}
